import { Button } from "primereact/button";
import React from "react";
import { useHistory } from "react-router-dom";

function RedirectToAllCompanies() {
  const history = useHistory();
  return (
    <div className="Down__Btn">
      <Button
        onClick={() => {
          history.push(`/allcompanies`);
        }}
        iconPos="left"
        icon="pi pi-angle-double-left"
        label={"All Companies"}
        className="Btn__Dark"
      />
    </div>
  );
}

export default RedirectToAllCompanies;
